<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.filterBetreff"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.subject") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model.trim="filters.filterBezeichnung"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model.trim="filters.filterKategorie"
                        :options="kategorien"
                        :reduce="(s) => s.id"
                        label="bezeichnung"
                        :placeholder="$t('global.category')"
                      >
                        <span slot="no-options">{{
                          $t("global.nostatusfound")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.category") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="navbarTitel"
              :gesamtanzahl="gesamtanzahl"
              :anzahl="anzahlDaten"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <router-link
                      v-if="berechtigungen.m_korrespondenz.create"
                      class="btn btn-success"
                      :to="{ name: 'Neue Korrespondenzvorlage' }"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </router-link>
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      v-if="berechtigungen.m_korrespondenz.delete"
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />{{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template v-slot:head(selected)="row">
                      <b-form-checkbox
                        v-model="row.selected"
                        @input="selectAllRows(row)"
                      ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="infiniteHandlerCommunication"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="korrespondenz-vorlage-loeschen-modal"
      @confirmed="loeschen"
      :selectedIds="selectedIds"
      :multiple="true"
    />
  </div>
</template>

<script>
//import DatePicker from "@/components/Datepicker";
import Api from "@/api/Api";
import { debounce } from "@/utils/Debouncer";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import CommunicationApi from "@/api/CommunicationApi";

import store from "@/store";
import page from "@/mixins/Page";
import CommunicationDashboard from "@/mixins/CommunicationDashboard";
import filter from "@/mixins/Filter";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import InfiniteLoading from "vue-infinite-loading";

import { LADE_AUSWAHLWERTE_KORRESPONDENZ } from "@/store/korrespondenz/actions.type";

export default {
  name: "KorrespondenzVorlagenListe",
  components: {
    Navbar,
    InfiniteLoading,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    FilterSearchResetButton,
  },
  mixins: [page, filter, CommunicationDashboard],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      /*       page: 0,
      anzahlProPage: 50,
      infiniteId: +new Date(),

      korrespondenzliste: [],
      filterBetreff: null,
      filterBezeichnung: null,
      filterKategorie: null, */

      sortBy: "bezeichnung",
      sortDesc: false,
      selected: [],
      selectedIds: [],
    };
  },
  computed: {
    navbarTitel() {
      return this.$t("global.templatescorrespondence");
    },
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        {
          key: "betreff",
          sortable: true,
          label: this.$t("global.subject"),
        },
        {
          key: "korrespondenzkategorie.bezeichnung",
          sortable: true,
          label: this.$t("global.category"),
        },
      ];
    },
    queryParams: function () {
      var params = {};

      if (this.filters.filterBetreff)
        params.filterBetreff = this.setQueryParam(this.filters.filterBetreff);
      if (this.filters.filterBezeichnung)
        params.filterBezeichnung = this.setQueryParam(
          this.filters.filterBezeichnung
        );
      if (this.filters.filterKategorie)
        params.filterKategorie = this.setQueryParam(
          this.filters.filterKategorie
        );

      return params;
    },
    kategorien: {
      get() {
        return this.$store.state.korrespondenz.kategorien;
      },
    },
  },
  watch: {
    /*  filterBetreff: function () {
      this.resetLoading(this);
    },
    filterBezeichnung: function () {
      this.resetLoading(this);
    },
    filterKategorie: function () {
      this.resetLoading(this);
    }, */
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
  },
  created() {
    this.initFilter(
      "template-korrespondenz-liste",
      "correspondence-template/",
      true
    );
    if (this.kategorien.length == 0)
      this.$store.dispatch(`korrespondenz/${LADE_AUSWAHLWERTE_KORRESPONDENZ}`);
  },
  methods: {
    details(vorlage) {
      this.$router.push({
        name: "korrespondenz-vorlage",
        params: { id: vorlage.id, anzeige: 0 },
      });
    },

    /* resetLoading: debounce((self) => {
      self.page = 0;
      self.korrespondenzliste = [];
      self.infiniteId += 1;
    }, 500), */

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit(
          "openLoeschenModal",
          "korrespondenz-vorlage-loeschen-modal"
        );
    },

    loeschen() {
      CommunicationApi.delete(
        "correspondence-template/",
        { data: this.selectedIds } /* {
        params: { ids: this.selectedIds.join(",") },
      } */
      ).then(() => {
        this.resetLoading(this);
      });
    },

    /* infiniteHandler($state) {
      Api.get("korrespondenz/vorlagen/", {
        params: this.queryParams,
      }).then((response) => {
        if (response.data.length === this.anzahlProPage) {
          this.page += 1;
          this.korrespondenzliste.push(...response.data);
          $state.loaded();
        } else {
          this.korrespondenzliste.push(...response.data);
          $state.complete();
        }
      });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((v) => {
          v.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((v) => {
          v.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    }, */
  },
};
</script>

<style></style>
